import React, { useState, useEffect } from "react";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  Avatar,
  TypingIndicator,
} from "@chatscope/chat-ui-kit-react";
import "./Chatbox.css";
import { fetchCoachData, postUserMessage } from "../../API/API";
import coachIcon from "../../coach.png";
import patientIcon from "../../patient.png";

function Chatbox({
  setType,
  setVersion,
}) {
  const [response, setResponse] = useState();
  const [messages, setMessages] = useState([]);
  const [typing, setTyping] = useState(false);
  const [responseTimes, setResponseTimes] = useState([]);

  const getCurrentTime = () => {
    const currentDate = new Date();
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    const seconds = String(currentDate.getSeconds()).padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  };

  const calculateAverageResponseTime = () => {
    if (responseTimes.length > 0) {
      const sumResponseTimes = responseTimes.reduce(
        (acc, time) => acc + time,
        0
      );
      const average = (sumResponseTimes / responseTimes.length) / 1000;

      // setAverageResponseTime(average.toFixed(1)); // Keep two decimal places
    }
  };

  const handleSend = async (message) => {
    setTyping(true);
    const startTime = new Date();

    const newUserMessage = {
      message: message,
      sender: "user",
      direction: "outgoing",
      sentTime: getCurrentTime(),
      sources: "",
    };
    setMessages((prevMessages) => [...prevMessages, newUserMessage]);

    try {
      const data = await postUserMessage(message);
      setResponse(data);


      const endTime = new Date();
      const responseTime = endTime - startTime;
      setResponseTimes((prevResponseTimes) => [
        ...prevResponseTimes,
        responseTime,
      ]);

      if (data.resources) {
        var sources = data.resources;
      }
      else {
        var sources = ""
      }
      const newCoachMessage = {
        message: data.output,
        sender: "coach",
        sentTime: getCurrentTime(),
        sources: sources,
      };
      setMessages((prevMessages) => [...prevMessages, newCoachMessage]);
    } catch (error) {
      console.error("Error sending message:", error);
    } finally {
      setTyping(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchCoachData();
        setResponse(data);
        setType(data.type);
        setVersion(data.version);
        document.cookie = `token=${data.access_token}`;

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    calculateAverageResponseTime();
  }, [responseTimes]);

  return (
    <div className="container">
      <div className="chat-box">
        <MainContainer>
          <ChatContainer className="chat-container">
            <MessageList
              typingIndicator={
                typing && <TypingIndicator style={{ backgroundColor: "#fff0" }} content="Bot is typing" />
              }
            >
              {messages.map((message, i) => (
                <React.Fragment key={i}>
                  <Message model={message}>

                  </Message>

                  <a className="message_sources" href={`https://bree-salliebot.eniweb.com/api/bot/pages/${encodeURIComponent(message.sources)}`} target="_blank" > {message.sources.replace(/\d/g, "")} </a>
                  {/* <a className="message_sources" href={`http://127.0.0.1:8002/api/bot/pages/${message.sources}`}  target="_blank" > {message.sources.replace(/\d/g, "")} </a> */}
                  <p className={`time${message.sender}`}>{message.sentTime}</p>
                </React.Fragment>
              ))}
            </MessageList>
            <MessageInput
              placeholder="Type message here"
              onSend={handleSend}
              className="message-input"
            // onChange={(e) => {
            //   var inp = document.getElementsByClassName("cs-message-input__content-editor");
            //   console.log(inp.item(0));
            //   var text = inp.value;
            //   var target = text.replaceAll("<[^>]*>", "");
            //   inp.value = target;
            // }}
            />
          </ChatContainer>
        </MainContainer>
      </div>
    </div>
  );
}

export default Chatbox;
